var React = require('react');

function GlobeIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"36.4799","cy":"9.6","r":"9.6","fill":"#FFCC00","key":0}),React.createElement("path",{"d":"M3.33301 40H76.6663H3.33301ZM39.9997 76.6667C46.9663 76.6667 52.833 60.1667 52.833 40C52.833 19.8334 46.9663 3.33337 39.9997 3.33337C33.033 3.33337 27.1663 19.8334 27.1663 40C27.1663 60.1667 33.033 76.6667 39.9997 76.6667ZM39.9997 76.6667C60.1663 76.6667 76.6663 60.1667 76.6663 40C76.6663 19.8334 60.1663 3.33337 39.9997 3.33337C19.833 3.33337 3.33301 19.8334 3.33301 40C3.33301 60.1667 19.833 76.6667 39.9997 76.6667Z","stroke":"#121212","strokeMiterlimit":"10","strokeLinecap":"square","key":1})]);
}

GlobeIcon.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = GlobeIcon;

GlobeIcon.default = GlobeIcon;
